import React, {FC} from 'react'
import CustomTable from '../../../../../common/components/tables/CustomTable'
import { useThemeMode } from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { useIntl } from 'react-intl'
type ProjectTableProps = {
  data: Array<{
    columns: Array<{
      colIndex: number
      value: any
      type: 'text' | 'date' | 'integer' | 'decimal' | 'percent'
      rowIndex: number
      dataKey: string
      rowGuid: string
      content?: any
    }>
    rowType: 'data' | 'header'
    rowIndex: number
    rowGuid: string
  }>
  onSort?: (crit: {Sort: string, Order: 'asc' | 'desc'}) => void;
  activeSort?: {Sort: string, Order: 'asc' | 'desc'}
  screenType: 'small' | 'large'
}
const ProjectTable: FC<ProjectTableProps> = ({data = [], screenType = 'large', activeSort, onSort}) => {
  const intl = useIntl()
  const {mode} = useThemeMode()
  return (
    <div className={'d-flex flex-column h-100'} style={{flex: 1}} data-bs-theme={mode}>
      <div data-bs-theme={mode} className={'fw-bolder fs-1 my-3'}>
        {intl.formatMessage({id: 'ESTIM_HISTORY'})}
      </div>
      <div 
      style={{...{flex: 1,}, ...(screenType === 'large' ? {maxHeight: '85%'} : {})}} 
      className={` ${screenType === 'large' ? ' overflow-auto ' : ''} ${screenType === 'small' ? ' overflow-x-auto ' : ''}  `}
      data-bs-theme={mode}
      >
        <CustomTable data={data} activeSort={activeSort} onSort={onSort} />
      </div>
    </div>
  )
}
export default ProjectTable
